import React from 'react'; 

const Social = () => {
  return (
    <div className="home__social">
        <a href="https://www.linkedin.com" className="home__social-icon" target="_black">
        <i class="uil uil-linkedin"></i>
        </a>
        <a href="https://www.github.com" className="home__social-icon" target="_black">
        <i class="uil uil-github-alt"></i>
        </a>
        <a href="https://www.instagram.com" className="home__social-icon" target="_black">
            <i class="uil uil-instagram"></i>
        </a>
    </div>

  )
}

export default Social
